module.exports = __webpack_public_path__ + "static/img/pico51.9c4c54b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico51.png
// module id = w1ea
// module chunks = 0